// extracted by mini-css-extract-plugin
export default {"deedsWrap":"deedsWrap___rRlyG","wrap":"wrap___hP3dc","slicedBackground":"slicedBackground___YL2fo","container":"container___Vd7IX","deedsContainer":"deedsContainer___rH0L4"};